export const NotificationTargetType = Object.freeze({ None: 0, Order: 1, RegistrationReview: 2 })
